var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Badge',{staticClass:"active-inactive-badge",class:{ 'badge-active': _vm.active }},[_c('i',{staticClass:"active-icon"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }